export default {
  trip: {
    method: 'get',
    url: '/client/shared/trip/ID'
  }
}
